module.exports = __webpack_public_path__ + "img/YANAO.cb8826c0.png";